import { render, staticRenderFns } from "./publishLazada.vue?vue&type=template&id=416eedda&scoped=true&"
import script from "./publishLazada.vue?vue&type=script&lang=js&"
export * from "./publishLazada.vue?vue&type=script&lang=js&"
import style0 from "./publishLazada.vue?vue&type=style&index=0&id=416eedda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416eedda",
  null
  
)

export default component.exports